module.exports = __webpack_public_path__ + "static/media/protagonistdepth.37c12f87.frag";